<template>
  <div>
    <div v-if="loaded" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>تاریخ</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="signIn in signIns" :key="signIn.id">
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(signIn.updated_at) }}
                </td>
                <td dir="ltr">{{ signIn.ip }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      v-if="signInsPagination.prevPageUrl || signInsPagination.nextPageUrl"
      class="overflow-auto mt-5"
    >
      <div class="btn-group" role="group">
        <button
          type="button"
          class="btn btn-primary"
          :disabled="!loaded || !signInsPagination.prevPageUrl"
          @click="prev"
        >
          قبلی
        </button>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="!loaded || !signInsPagination.nextPageUrl"
          @click="next"
        >
          بعدی
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  UPDATE_SIGN_INS,
  SWITCH_PAGE
} from "@/core/services/store/signins.module";
import { mapGetters } from "vuex";

export default {
  name: "sign-ins",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "ورودها" }]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.loaded = false;
    this.$store
      .dispatch(UPDATE_SIGN_INS)
      .then(() => {
        this.loaded = true;
      })
      .catch(() => {
        this.loaded = true;
      });
  },
  computed: {
    ...mapGetters(["signIns", "signInsPagination"])
  },
  methods: {
    prev() {
      this.loaded = false;
      this.$store
        .dispatch(SWITCH_PAGE, "prev")
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    next() {
      this.loaded = false;
      this.$store
        .dispatch(SWITCH_PAGE, "next")
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
